export default __webpack_public_path__ + "static/media/confirm-warning.6c3fa338.svg";